export default __webpack_public_path__ + "static/114-min-min-af22b806344889336493f03b316fe5a4.jpg";